import { render } from "./dialogTableList.vue?vue&type=template&id=4977fc1d&scoped=true"
import script from "./dialogTableList.vue?vue&type=script&lang=js"
export * from "./dialogTableList.vue?vue&type=script&lang=js"

import "./dialogTableList.vue?vue&type=style&index=0&id=4977fc1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4977fc1d"]])

export default __exports__